exports.__esModule = true;
exports.Language = void 0;
var Language;
(function (Language) {
  Language["FR"] = "fr";
  Language["EN"] = "en";
  // eslint-disable-next-line
})((Language = exports.Language || (exports.Language = {})));
